module.exports = __webpack_public_path__ + "img/fill-blank-1.2e84c0e3.jpg";